import { Col, ItemList, Row } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Filters, SearchBar } from '../components';

let timer;
const Store = ({}) => {
  const [loading, setLoading] = useState(false),
    [filter, setFilter] = useState(null),
    [text, setText] = useState(''),
    [results, setResults] = useState(null),
    user = useSelector((state) => state.user),
    store = useSelector((state) => state.store),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    navigate = useNavigate();

  useEffect(() => {
    clearTimeout(timer);

    timer = setTimeout(getStore);
  }, []);

  useEffect(() => {
    getProducts();
  }, [filter, text]);

  function handleFilterChange(val) {
    setFilter(val === filter ? null : val);
  }

  async function getProducts() {
    if (!filter && !text) return setResults(null);

    const res = await Api.post('/store/getProducts', { filter, text });

    if (!res) return;

    setResults(res);
  }

  async function getStore() {
    const res = await Api.get('/store/initial');
    if (!res) return;

    dispatch({
      type: 'SET_STORE',
      payload: res
    });

    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        rates: res.rates
      }
    });
  }
  console.log('isMobile', isMobile);
  return (
    <Row centerAll wid="100%">
      <Col wid={isMobile ? '100vw' : '936px'} noFlex>
        <Row
          between={isMobile}
          marg={isMobile ? '16px 0 0' : '40px 0 0'}
          start={!isMobile}
          style={{ flexDirection: isMobile ? 'column' : 'row' }}
        >
          <Row
            noFlex
            wid="100%"
            center={!isMobile}
            style={{ flexDirection: isMobile ? 'column' : 'row' }}
          >
            <Row
              start
              wid={isMobile && 'calc(100% - 32px)'}
              pad={isMobile && '0 16px 16px'}
              between={isMobile}
            >
              <SearchBar text={text} setText={setText} />

              {/*isMobile && <CartButton />*/}
            </Row>

            <Filters filter={filter} handleFilterChange={handleFilterChange} />
          </Row>

          {/*!isMobile && <CartButton />*/}
        </Row>

        {!results ? (
          <ItemList
            handleClick={() => navigate('/products')}
            title={t('store.suggestedItems')}
            data={store?.suggested}
          />
        ) : (
          <ItemList data={results} limitless />
        )}
      </Col>
    </Row>
  );
};

export default Store;
